// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"55caa9a4","98":"bccc8e95","411":"722ef78c","532":"89a0d235"}[chunkId] + ".chunk.css";
};